<template>
  <BackPageLayout>
    <template #headline>
      {{ component?.config.title }}
    </template>

    <div v-for="center in centers" :key="center.id" class="py-4">
      <SalesCard :show-labels="true" :title="center.title" :show-chart="true"
        :center="center.id" :component="component!.id" :show-evolution="true" />
    </div>
  </BackPageLayout>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useUserManagerStore } from '../stores/userManagerStore';
import { useSalesReportsStore } from '../stores/salesReports'
import { computed, onMounted } from 'vue';
import BackPageLayout from '../layouts/BackPageLayout.vue';
import SalesCard from '../components/SalesCard.vue';

const router = useRouter();
const userManagerStore = useUserManagerStore()
const salesReportStore = useSalesReportsStore()

const id = router.currentRoute.value.params.id as string;

const component = computed(() => {
  return userManagerStore.user?.components.find((c) => c.id === id);
})

const centers = computed(() => {
  return userManagerStore.displayedCenters
})

onMounted(async () => {
  await salesReportStore.fetchAllSalesReports()
})
</script>